import React from 'react'
import { Link } from 'react-router-dom'

// images
import Logo from '../../images/logo-5.png'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const Footer = (props) => {
    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={Logo} alt="logo" />
                                </div>
                                <p>
                                    We build high-quality homes with a strong focus on smart design, durable materials,
                                    and a seamless construction process from start to finish.
                                </p>
                                <div className="social-widget">
                                    <ul>
                                        <li>
                                            <Link onClick={ClickHandler} to="#"><i className="ti-facebook"></i></Link>
                                            <Link onClick={ClickHandler} to="#"><i className="ti-twitter-alt"></i></Link>
                                            <Link onClick={ClickHandler} to="#"><i className="ti-linkedin"></i></Link>
                                            <Link onClick={ClickHandler} to="#"><i className="ti-instagram"></i></Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div
                            className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation"
                            data-animation="fade_from_bottom"
                        >
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Contact</h3>
                                </div>
                                <ul>
                                    <li>Email: <a href="mailto:qualityhomesinvic@gmail.com">qualityhomesinvic@gmail.com</a></li>
                                    <li>Phone: <a href="tel:0287985845"> 02 8798 5845</a></li>
                                    {/* <li>WhatsApp: <a href="https://wa.me/61452456856" target="_blank" rel="noopener noreferrer"> 02 8798 5845</a></li> */}
                                    <li>
                                        Address: {' '}
                                        <a
                                            href="https://www.google.com/maps/search/?api=1&query=Unit+1+40B+Wallace+Avenue+Point+Cook+VIC+3030"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Unit 1
                                            40 B Wallace Avenue
                                            Point cook ViC 3030
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>

                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Quick Link</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/"><span className="rolling-text">Home</span> </Link></li>
                                    <li><Link onClick={ClickHandler} to="/about"><span className="rolling-text">About Us</span> </Link></li>
                                    {/* <li><Link onClick={ClickHandler} to="/services"><span className="rolling-text">Services</span> </Link></li> */}
                                    <li><Link onClick={ClickHandler} to="/projects"><span className="rolling-text">Projects</span></Link></li>
                                    {/* <li><Link onClick={ClickHandler} to="/blog"><span className="rolling-text">Blog</span> </Link></li> */}
                                    <li><Link onClick={ClickHandler} to="/contact"><span className="rolling-text">Contact</span></Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                            <div className="widget newsletter-widget">
                                <div className="widget-title">
                                    <h3>Newsletter</h3>
                                </div>
                                <form>
                                    <input
                                        type="email"
                                        className="input-fild"
                                        placeholder="Your Email..."
                                    />
                                    <button
                                        style={{
                                            backgroundColor: "#FACD2B",
                                            borderColor: "#FACD2B",
                                            color: "#000",          // better contrast
                                        }}
                                    >Subscribe</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container-fluid">
                    <div className="row g-0">
                        <div className="col col-lg-6 col-12">
                            <p className="copyright">
                                Copyright &copy; {new Date().getFullYear()}
                                <a
                                    href="https://www.mavrosstudio.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ marginLeft: "4px", color: "#000000ff", textDecoration: "none", fontWeight: "bold" }}
                                >
                                    Mavros Studio
                                </a>. All Rights Reserved.
                            </p>
                        </div>

                        <div className="col col-lg-6 col-12">
                            <ul className="right">
                                {/* <li><Link onClick={ClickHandler} to="/privace"><span className="rolling-text">Privace & Policy</span> </Link></li> */}
                                {/* <li><Link onClick={ClickHandler} to="/terms"><span className="rolling-text">Terms</span></Link></li> */}
                                {/* <li><Link onClick={ClickHandler} to="/about"><span className="rolling-text">About us</span></Link></li> */}
                                {/* <li><Link onClick={ClickHandler} to="/login"><span className="rolling-text">Login</span></Link></li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;


